import {
  doc,
  DocumentData,
  getDoc,
  setDoc,
  updateDoc,
} from 'firebase/firestore';
import { firestore, auth } from './client';
import { IUser } from 'utils/types/User';

export const UpdateHouse2Firebase = async (
  collection: string,
  updatedData: IUser,
  newID?: string,
): Promise<void> => {
  const updatedDataWithID: IUser = {
    ...updatedData,
    id: newID ?? updatedData.id,
  };
  const docRef = doc(firestore, collection, updatedDataWithID.id);

  const documentData = updatedData as DocumentData;

  const docSnapshot = await getDoc(docRef);

  if (docSnapshot.exists()) {
    await updateDoc(docRef, documentData);
  } else {
    await setDoc(docRef, documentData);
  }
  // await updateDoc(docRef, documentData);
};

export const updateUserPhoneNumber = async (
  phoneNumber: string,
): Promise<void> => {
  if (!auth.currentUser) {
    throw new Error('Usuário não autenticado');
  }

  const userDocRef = doc(firestore, 'subscription_users', auth.currentUser.uid);

  try {
    await updateDoc(userDocRef, {
      phoneNumber: phoneNumber,
    });
  } catch (error) {
    console.error('Erro ao atualizar telefone no Firebase:', error);
    throw new Error('Falha ao atualizar telefone');
  }
};
